import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListParams, ReferenceParams, Res } from '../models';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiBasicService {

  constructor(
    private api: ApiService,
  ) { }


  /**
   * 
   * @param params 
   * @returns 
   */
  getAttrPresentTypeId(params): Observable<Res> {

    return this.api.post('references/attr_valid_value_types', params, 'private');
  }

  /**
   * 
   * @param params ReferenceParams
   * @returns Observable<Res>
   */
  getReferences(params: ReferenceParams, moduleName: string): Observable<Res> {

    return this.api.post('references/' + moduleName, params, 'private');
  }


  /**
   * 
   * @param params List
   * @returns Observable<Res>
   */
  getList(params: ListParams, moduleName: string): Observable<Res> {

    return this.api.post(moduleName + '/list', params, 'private');
  }

  /**
   * 
   * @param params List
   * @returns Observable<Res>
   */
  getAlListIds(methodName: string, params: any): Observable<Res> {

    return this.api.post('select_all/' + methodName, params, 'private', 'files');
  }

  /**
   * 
   * @param params 
   * @param moduleName 
   * @returns 
   */
  getAttributList(params: ListParams, moduleName: string): Observable<Res> {

    return this.api.post('attributes/list', params, 'private', 'files');
  }


  /**
   * 
   * @param objectName string
   * @returns Observable<Res>
   */
  getInfo(objectName: string, objectId: string = ''): Observable<Res> {

    return this.api.get(objectName + '/profile', objectId, 'private');
  }


  /**
   * 
   * @param objectName string
   * @param objectId string
   * @returns Observable<Res>
   */
  edit(objectName: string, objectId: string): Observable<Res> {

    return this.api.get(objectName + '/edit', objectId, 'private');
  }


  /**
   * 
   * @param objName string
   * @param params any
   * @returns Observable<Res>
   */
  create(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName + '/create', params, 'private');
  }

  /**
  * 
  * @param objName string
  * @param params any
  * @returns Observable<Res>
  */
  update(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName + '/update', params, 'private');
  }

  /**
   * 
   * @param objName string
   * @param params any
   * @returns Observable<Res>
   */
  delete(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName + '/delete', params, 'private');
  }


  /**
   * 
   * @param objectName 
   * @param params 
   * @returns 
   */
  deleteRole(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName, params, 'private');
  }


  /**
   * 
   * @param objectName 
   * @param params 
   * @returns 
   */
  roleControl(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName, params, 'private');
  }

  /**
   * 
   * @param objectName 
   * @param params 
   * @returns 
   */
  deleteAttribute(params: any): Observable<Res> {

    return this.api.post('deleteAttribute', params, 'private', 'files');
  }

  /**
   * 
   * @param objectName 
   * @param params 
   * @returns 
   */
  deleteSpecifications(params: any): Observable<Res> {

    return this.api.post('deleteSpecification', params, 'private', 'files');
  }


  /**
   * 
   * @param params 
   * @returns 
   */
  attributeMandatory(params: any): Observable<Res> {

    return this.api.post('makeAttrMandatory', params, 'private', 'files');
  }

  /**
   * 
   * @param objName string
   * @param params any
   * @returns Observable<Res>
   */
  onSearch(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName + '/search', params, 'private');
  }

  /**
   * 
   * @param objName string
   * @param params any
   * @returns Observable<Res>
   */
  changeUserState(objectName: string, params: any, state: string): Observable<Res> {

    return this.api.post(objectName + '/' + state, params, 'private');
  }

  /**
  * 
  * @param objName string
  * @param params any
  * @returns Observable<Res>
  */
  changeState(objectName: string, params: any): Observable<Res> {

    return this.api.post(objectName + '/changeStateToReaded', params, 'private');
  }
}
